import {Route} from "../../registry/routes.js"
import Dashboard from "../../components/dashboard/DashboardMain.vue"

const r = new Route("dashboard", "dashboard", {"dashboard":Dashboard}, {componentType:"main_component", title: "Dashboard"}, [], true, null)

export default r